const ALL_ROLES = ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR", "COUNTER_USER", "VERIFICATION_USER"];

export const PAGE_GROUPS = [
  {
    module: "PROTOCOL",
    label: "Protocol Darshan",
    pages: [
      { key: "PROTOCOL_DASHBOARD", label: "Protocol Darshan Dashboard", roles: ALL_ROLES },
      { key: "ADVANCED", label: "Advanced Booking", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "CURRENT", label: "Current Booking", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "PENDING", label: "Pending Approvals", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR"] },
      { key: "ISSUE", label: "Ticket Issue", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "VERIFY", label: "Entrance Verification", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "VERIFICATION_USER"] },
      { key: "TRANSACTIONS", label: "Transaction Search", roles: ALL_ROLES },
      { key: "PROTOCOL_REPORTS", label: "Protocol Reports", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR", "COUNTER_USER"] },
      { key: "PROTOCOL_SHIFT_CLOSING", label: "Shift-wise DCR Closing (Protocol)", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR", "COUNTER_USER"] },
    ],
  },
  {
    module: "SAREES",
    label: "Sarees",
    pages: [
      { key: "SAREE_DASHBOARD", label: "Sarees Dashboard", roles: ALL_ROLES },
      { key: "SAREE_REQUEST", label: "Receiving Counter", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "SAREE_GODOWN_IN", label: "Godown In", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "VERIFICATION_USER", "COUNTER_USER"] },
      { key: "SAREE_GODOWN_OUT", label: "Godown Out", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "VERIFICATION_USER", "COUNTER_USER"] },
      { key: "SAREE_SALES", label: "Contract Sales", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "SAREE_DEVASTHANAM", label: "Devasthanam Sales", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "SAREE_REPORTS", label: "Saree Details Report", roles: ALL_ROLES },
      { key: "SAREE_SHIFT_CLOSING", label: "Shift-wise DCR Closing (Sarees)", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR", "COUNTER_USER"] },
    ],
  },
  {
    module: "ANNAPRASADAM",
    label: "Annaprasadam",
    pages: [
      { key: "ANNA_DASHBOARD", label: "Annaprasadam Dashboard", roles: ALL_ROLES },
      { key: "ANNA_ISSUE", label: "Annaprasadam Ticket Issue", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "ANNA_VERIFY", label: "Annaprasadam Verification", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "VERIFICATION_USER", "COUNTER_USER"] },
      { key: "ANNA_REPORTS", label: "Annaprasadam Reports", roles: ALL_ROLES },
    ],
  },
  {
    module: "HUNDIAL",
    label: "Hundial",
    pages: [
      { key: "HUNDIAL_DASHBOARD", label: "Hundial Dashboard", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR"] },
      { key: "HUNDIAL_ENTRY", label: "Hundial Opening Entry", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN"] },
      { key: "HUNDIAL_REPORTS", label: "Hundial Reports", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR"] },
    ],
  },
  {
    module: "IDENTITY",
    label: "Identity & Passes",
    pages: [
      { key: "ID_DASHBOARD", label: "Identity Dashboard", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR"] },
      { key: "ID_SCAN", label: "QR Scanner / Verify", roles: ALL_ROLES },
      { key: "ID_DUTY", label: "Duty Pass", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "ID_VEHICLE", label: "Vehicle Pass", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "ID_CHILDREN", label: "Children Tag", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER", "VERIFICATION_USER"] },
      { key: "ID_PANDITS", label: "Pandits", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "COUNTER_USER"] },
      { key: "ID_APPROVALS", label: "Identity Approvals", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN"] },
      { key: "ID_MASTERS", label: "Departments / Locations / Sacred Locations / Tag Ranges", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN"] },
      { key: "ID_REPORTS", label: "Identity Reports", roles: ["SUPER_ADMIN", "TEMPLE_ADMIN", "SUPERVISOR"] },
    ],
  },
];

const ALL_PAGES = PAGE_GROUPS.flatMap((g) => g.pages.map((p) => ({ ...p, module: g.module })));

export const defaultPagesFor = (role, modules) =>
  ALL_PAGES.filter((p) => (modules || ["PROTOCOL", "SAREES"]).includes(p.module) && p.roles.includes(role)
    && !(["COUNTER_USER", "VERIFICATION_USER"].includes(role) && p.key.endsWith("_DASHBOARD"))).map((p) => p.key);

export const userPages = (user) =>
  user?.pages?.length ? user.pages : defaultPagesFor(user?.role, user?.modules);

export const pageRoleOk = (key, role) => {
  const p = ALL_PAGES.find((x) => x.key === key);
  return !!p && p.roles.includes(role);
};
